import { render, staticRenderFns } from "./CoachChatComponent.vue?vue&type=template&id=88702f44&scoped=true&"
import script from "./CoachChatComponent.vue?vue&type=script&lang=js&"
export * from "./CoachChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoachChatComponent.vue?vue&type=style&index=0&id=88702f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88702f44",
  null
  
)

export default component.exports